(() => {
  const initializePdp = (root) => {
    if (!root || root.dataset.lnpReady === 'true') return;
    root.dataset.lnpReady = 'true';

    root.querySelectorAll('[data-lnp-gallery]').forEach((gallery) => {
      const slides = [...gallery.querySelectorAll('[data-lnp-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-lnp-target]')];

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const target = thumb.dataset.lnpTarget;
          slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.lnpSlide === target));
          thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
        });
      });
    });

    const productInfo = root.closest('product-info');
    if (!productInfo) return;

    const priceContainer = productInfo.querySelector(`#price-${productInfo.dataset.section}`);
    const mainSubmit = productInfo.querySelector(`#ProductSubmitButton-${productInfo.dataset.section}`);
    const mobileSubmit = root.querySelector('[data-lnp-mobile-cart] button');

    const setTextIfChanged = (element, value) => {
      if (!element || !value || element.textContent.trim() === value) return;
      element.textContent = value;
    };

    const setAttributeIfChanged = (element, name, value) => {
      if (!element || element.getAttribute(name) === value) return;
      element.setAttribute(name, value);
    };

    const syncPurchaseState = () => {
      const customPrice = priceContainer?.querySelector('.lnp-current-price, .lnb-current-price');
      const salePrice = priceContainer?.querySelector('.price--on-sale .price-item--sale');
      const regularPrice = priceContainer?.querySelector('.price-item--regular');
      const livePrice = customPrice || salePrice || regularPrice;
      const buttonPrice = root.querySelector('[data-lnp-button-price]');
      const mobilePrice = root.querySelector('[data-lnp-mobile-price]');

      const livePriceText = livePrice?.textContent.trim();
      setTextIfChanged(buttonPrice, livePriceText);
      setTextIfChanged(mobilePrice, livePriceText);

      if (mainSubmit && mobileSubmit) {
        const isDisabled = mainSubmit.disabled || mainSubmit.getAttribute('aria-disabled') === 'true';
        const isLoading = mainSubmit.classList.contains('loading');

        if (mobileSubmit.disabled !== isDisabled) mobileSubmit.disabled = isDisabled;
        setAttributeIfChanged(mobileSubmit, 'aria-disabled', String(isDisabled));
        setAttributeIfChanged(mobileSubmit, 'aria-busy', String(isLoading));
        if (mobileSubmit.classList.contains('loading') !== isLoading) {
          mobileSubmit.classList.toggle('loading', isLoading);
        }

        const mainLabel = mainSubmit.querySelector('span')?.textContent.trim();
        const mobileLabel = mobileSubmit.querySelector('span');
        setTextIfChanged(mobileLabel, mainLabel);
      }
    };

    syncPurchaseState();

    if (priceContainer) {
      new MutationObserver(syncPurchaseState).observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (mainSubmit) {
      new MutationObserver(syncPurchaseState).observe(mainSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
      });
    }
  };

  const boot = () => document.querySelectorAll('[data-lnp-root]').forEach(initializePdp);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
